module.exports = __webpack_public_path__ + "static/media/virtual.26141968.svg";